import { join } from 'path';
import { createHashHistory } from 'history';
import { Card, CardBody, CardHeader, CardFooter, TabContent, TabPane, Nav, NavItem, Button, Row, Col, Container, NavLink } from 'reactstrap';
import { Prompt } from 'react-router-dom';
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { kebabCase } from 'lodash';
import entityComposition from '../common/classes/entityComposition';
import routeHelper from '../common/classes/routeHelper';
import EditorComponent from '../editor/editorComponent';
import SaveButton from '../common/controls/saveButton';
import Loader from '../common/loader';
const hashHistory = createHashHistory();
class FluidIssueEditor extends Component {
  constructor(props) {
    super(props);
    this.getSectionIndex = this.getSectionIndex.bind(this);
    this.getSectionFormat = this.getSectionFormat.bind(this);
    this.getSections = this.getSections.bind(this);
    this.handleSelectSection = this.handleSelectSection.bind(this);
    this.handleChange = this.handleChange.bind(this);
    this.handleViewReportClick = this.handleViewReportClick.bind(this);
    this.handleSave = this.handleSave.bind(this);
    this.state = {
      sectionIndex: null
    };
  }
  componentWillUnmount() {
    const {
      issueActions
    } = this.props;
    issueActions.showCancel();
  }
  getSectionIndex() {
    const {
      sectionIndex
    } = this.state;
    if (sectionIndex) {
      return sectionIndex;
    }

    // return the first section.
    const sections = this.getSections();
    if (sections && sections.length > 0) {
      return sections[0].label;
    }
    // what should we return as default?
    return 'General';
  }
  getSections() {
    const {
      issue: {
        active: {
          format = {}
        }
      }
    } = this.props;
    if (format && format.children) {
      // Return only visible sections (i.e. visible is not set to false)
      return format.children.map(child => ({
        label: child.label,
        format: child
      })).filter(section => section.format.visible !== undefined && section.format.visible === true || section.format.visible === undefined);
    }
    return [];
  }
  getSectionFormat() {
    const sectionKey = this.getSectionIndex();
    const sections = this.getSections();
    const section = sections.find(currentSection => currentSection.label === sectionKey);
    return section ? section.format : undefined;
  }
  handleSelectSection(sectionkey) {
    this.setState({
      sectionIndex: sectionkey
    });
  }
  handleSave(...args) {
    const {
      handleSave
    } = this.props;
    handleSave(...args);
  }
  handleChange({
    path,
    value,
    changeModifiers
  }) {
    const {
      issueActions,
      issueID
    } = this.props;
    // create a change action with the new info.
    // need to prepend the content object to this keypath
    issueActions.change(issueID, join('content', path), value, changeModifiers);
  }
  handleViewReportClick() {
    const {
      issue: {
        active: {
          reportID
        }
      }
    } = this.props;
    hashHistory.push(`/reports/edit/${reportID}`);
  }
  render() {
    const {
      handleSave,
      issue: {
        active,
        loading,
        pendingChanges
      },
      footer,
      saveState,
      issueActions: {
        operationComplete,
        operationPending
      }
    } = this.props;
    const {
      reportID
    } = active;
    const ready = active && active.issueType;
    const sectionIndex = this.getSectionIndex();
    const sectionFormat = this.getSectionFormat();
    const sections = this.getSections();
    let sectionKeyPath = null;
    if (sectionFormat && sectionFormat.children) {
      sectionKeyPath = sectionFormat.contentPath ? sectionFormat.contentPath : '/';
    }
    return /*#__PURE__*/React.createElement(Container, null, /*#__PURE__*/React.createElement(Prompt, {
      when: pendingChanges,
      message: location => routeHelper.transitionAsync(this, 'issue', location)
    }), /*#__PURE__*/React.createElement(Row, null, /*#__PURE__*/React.createElement(Col, {
      sm: 3
    }, /*#__PURE__*/React.createElement(Card, null, /*#__PURE__*/React.createElement(CardHeader, {
      className: "card-heading"
    }, /*#__PURE__*/React.createElement("h3", null, "Issue Sections")), /*#__PURE__*/React.createElement(CardBody, null, /*#__PURE__*/React.createElement(Nav, {
      vertical: true,
      pills: true
    }, sections.map(section => /*#__PURE__*/React.createElement(NavItem, {
      style: {
        maxWidth: '100%'
      },
      className: `t-re-nav-section-${kebabCase(section.label)}`,
      active: sectionIndex === section.label,
      key: `NAV_${section.label.replace(/[\s-]/g, '')}`
    }, /*#__PURE__*/React.createElement(NavLink, {
      onClick: () => this.handleSelectSection(section.label)
    }, section.label))))))), /*#__PURE__*/React.createElement(Col, {
      sm: 9
    }, /*#__PURE__*/React.createElement(Card, {
      id: "detail-card-header",
      className: "t-section-panel"
    }, /*#__PURE__*/React.createElement(CardHeader, {
      className: "card-heading"
    }, reportID ? /*#__PURE__*/React.createElement("div", {
      style: {
        float: 'left'
      }
    }, /*#__PURE__*/React.createElement(Button, {
      className: "float-right",
      onClick: this.handleViewReportClick
    }, "Edit Report")) : null, /*#__PURE__*/React.createElement("div", {
      style: {
        float: 'right',
        paddingBottom: active.id ? 0 : 20
      }
    }, /*#__PURE__*/React.createElement(SaveButton, {
      onSave: handleSave,
      saveState: saveState,
      className: "t-idvp-save",
      size: "sm"
    }))), /*#__PURE__*/React.createElement(CardBody, null, /*#__PURE__*/React.createElement(Loader, {
      loaded: !loading
    }, /*#__PURE__*/React.createElement(TabContent, {
      activeTab: sectionIndex
    }, sections.length ? sections.map(section => /*#__PURE__*/React.createElement(TabPane, {
      tabId: section.label,
      key: `KEY_${kebabCase(section.label)}`,
      className: `t-i-nav-pane-${kebabCase(section.label)}`
    }, ready ? /*#__PURE__*/React.createElement(EditorComponent, {
      minControlWidth: 25,
      reduxEntity: "issue",
      path: sectionKeyPath,
      format: sectionFormat,
      onChange: this.handleChange,
      operationComplete: operationComplete,
      operationPending: operationPending
    }) : null)) : /*#__PURE__*/React.createElement("h3", {
      className: "t-ie-edit-header"
    }, "Select an issue to edit or click to create")))), footer ? /*#__PURE__*/React.createElement(CardFooter, {
      style: {
        paddingLeft: 10,
        paddingRight: 10
      }
    }, footer) : null))));
  }
}
FluidIssueEditor.defaultProps = {
  saveState: 'disabled',
  issueID: null,
  footer: null
};
FluidIssueEditor.propTypes = {
  handleSave: PropTypes.func.isRequired,
  issueID: PropTypes.string,
  footer: PropTypes.node,
  issue: PropTypes.shape({
    active: PropTypes.shape({
      issueType: PropTypes.shape({}),
      reportID: PropTypes.string,
      content: PropTypes.shape({}),
      format: PropTypes.shape({}),
      id: PropTypes.string
    }),
    loading: PropTypes.bool,
    pendingChanges: PropTypes.bool
  }).isRequired,
  issueActions: PropTypes.shape({
    showCancel: PropTypes.func,
    change: PropTypes.func,
    operationPending: PropTypes.func,
    operationComplete: PropTypes.func
  }).isRequired,
  saveState: PropTypes.string
};
export { FluidIssueEditor as TestFluidIssueEditor };
export default entityComposition(FluidIssueEditor, ['issue']);